
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>Technische Hinweise</div>
<MDXTag name="p" components={components}>{`Die Gefahrenkarten der einzelnen Kantone wurden vom Tamedia-Datenteam in elektronischer Form beschafft und in eine einheitliche Form gebracht. Die Karten können auch auf den Geoportalen der jeweiligen Kantone betrachtet werden. Teilweise sind dort noch mehr Inhalte zu finden, wie zum Beispiel Karten für weitere Gefahren (Steinschlag oder Erdrutsch) oder auch Gefahrenhinweiskarten für Gebiete ausserhalb der Siedlungsgebiete. In den Kantonen Solothurn, Jura, Zug, Tessin und Graubünden gibt es einzelne Gebiete die noch nicht erfasst wurden. Die kann auf der Seite des `}<a href='https://www.bafu.admin.ch/bafu/de/home/themen/naturgefahren/fachinformationen/naturgefahrensituation-und-raumnutzung/gefahrengrundlagen/gefahrenkarten--intensitaetskarten-und-gefahrenhinweiskarten.html'>{`Bundesamts für Umwelt`}</a>{` nachgeschaut werden`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  